import { ApiSignupVerifyResponseCookieSchema, type TApiSignupVerifyResponseCookie } from "@/api/launcherApp/signup/schema"
import { makeID } from "@/lib/stringUtils"

/**
 * Parse the Set-Cookie header into an array of cookies
 * @param header - The Set-Cookie header
 * @returns An array of cookies
 */
export function parseSetCookieHeader(header: string): TApiSignupVerifyResponseCookie[] {
  const splitted = header.split(",")
  const cookies: TApiSignupVerifyResponseCookie[] = []

  for (const cookie of splitted) {
    const [nameValue, ...params] = cookie.split(";").map((part) => part.trim())
    const [name, value] = nameValue.split("=")
    const cookieObject: Record<string, string | undefined> = { name, value }

    params.forEach((param) => {
      const [key, val] = param.split("=")
      cookieObject[key.toLowerCase()] = val || undefined
    })

    const safeCookie = ApiSignupVerifyResponseCookieSchema.safeParse({
      name,
      value,
      path: cookieObject.path ?? "",
      domain: cookieObject.domain ?? "",
      expires: cookieObject.expires ?? "",
      maxAge: cookieObject.maxAge ?? 0,
      secure: cookieObject.secure ?? undefined,
    })

    if (safeCookie.success) {
      cookies.push(safeCookie.data)
    }
  }

  return cookies
}

/**
 * Build a cookie string from an array of cookies
 * @param cookies - The array of cookies
 * @returns A cookie string
 */
export function buildCookieString(cookies: TApiSignupVerifyResponseCookie[]): string {
  const v = cookies
    .map((cookie) => {
      let retString = `${cookie.name}=${cookie.value}`

      //   if (cookie.path) {
      //     retString += `; Path=${cookie.path}`
      //   }

      //   if (cookie.domain) {
      //     retString += `; Domain=${cookie.domain}`
      //   }

      //   if (cookie.expires) {
      //     retString += `; Expires=${cookie.expires}`
      //   }

      //   if (cookie.maxAge !== undefined && cookie.maxAge !== null && cookie.maxAge >= 0) {
      //     retString += `; Max-Age=${cookie.maxAge}`
      //   }

      //   if (cookie.secure !== undefined) {
      //     retString += cookie.secure ? "; Secure" : ""
      //   }

      return retString
    })
    .join("; ")

  if (!v.endsWith(";") && cookies.length === 1) {
    return `${v};`
  } else if (v.endsWith(";") && cookies.length > 1) {
    // Remove the last semicolon
    return v.slice(0, -1)
  }

  return v
}

/**
 * Build a JSESSIONID cookie
 * @returns A JSESSIONID cookie
 */
export function buildJSessionIDCookie(): TApiSignupVerifyResponseCookie {
  return {
    name: "JSESSIONID",
    value: makeID(32),
    path: "/launcher-app",
    domain: process.env.NEXT_PUBLIC_BASE_SIGNUP_URL!.split("://")[1].split(":")[0],
    expires: "",
    maxAge: -1,
    secure: true,
  } satisfies TApiSignupVerifyResponseCookie
}
